import * as Sentry from "@sentry/react";

declare const __SENTRY_RELEASE__: string;

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://7996352ffcf3efd9d3b48b6c07a4f756@o4511138880421888.ingest.us.sentry.io/4511195262812160",
    release: __SENTRY_RELEASE__,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}
